import React, { useState } from 'react';

import { Grid, Typography } from '@material-ui/core';
import DescriptionIcon from '@material-ui/icons/Description';
import ReceiptIcon from '@material-ui/icons/Receipt';

import { formatMoeda } from '../../../utils';
import { PERMISSAO_TELA_INDICADORES_FISCAIS_LISTAR } from '../../../utils/dadosTelas';
import { ProtegerPagina } from '../../VerificaPermissaoPage';
import BlocoTipoNota from './BlocoTipoNota';
import CartaoIndicador from './CartaoIndicador';
import { CARTOES_RESUMO, NFCE_COR, NFE_COR } from './constantes';
import FiltroPeriodo, { obterPeriodoPadrao } from './FiltroPeriodo';
import useIndicadoresFiscais from './useIndicadoresFiscais';

function DashboardIndicadoresFiscais() {
  const [periodo, setPeriodo] = useState(obterPeriodoPadrao());
  const dados = useIndicadoresFiscais(periodo);

  return (
    <div style={{ padding: 20 }}>
      <Typography variant="h6" style={{ marginBottom: 16 }}>
        Dashboard
      </Typography>

      <FiltroPeriodo periodo={periodo} onChange={setPeriodo} />

      <Grid container spacing={2} style={{ marginTop: 8 }}>
        {CARTOES_RESUMO.map((cartao) => {
          const item = dados[cartao.chave] || {};
          return (
            <Grid item xs={12} sm={6} md={4} key={cartao.chave}>
              <CartaoIndicador
                rotulo={cartao.rotulo}
                destaque={item.count || 0}
                subtitulo={formatMoeda(item.total || 0)}
                cor={cartao.cor}
                icone={cartao.icone}
              />
            </Grid>
          );
        })}
      </Grid>

      <Grid container spacing={2} style={{ marginTop: 8 }}>
        <Grid item xs={12} md={6}>
          <BlocoTipoNota
            titulo="NF-e"
            cor={NFE_COR}
            icone={<ReceiptIcon />}
            dados={dados.nfe}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <BlocoTipoNota
            titulo="NFC-e"
            cor={NFCE_COR}
            icone={<DescriptionIcon />}
            dados={dados.nfce}
          />
        </Grid>
      </Grid>
    </div>
  );
}

function IndicadoresFiscais() {
  return (
    <ProtegerPagina permissao={PERMISSAO_TELA_INDICADORES_FISCAIS_LISTAR}>
      <DashboardIndicadoresFiscais />
    </ProtegerPagina>
  );
}

export default IndicadoresFiscais;
